<script lang="ts" setup>
import { onUnmounted, onMounted } from 'vue'
import { LayerSpecification } from 'mapbox-gl'
import { useMapBox } from './composables/useMapBox'

export interface Props {
	spec: LayerSpecification
	beforeId?: string
}

const props = withDefaults(defineProps<Props>(), {})

const { map } = useMapBox()

function removeLayer() {
	if (typeof map?.value?.getLayer(props.spec.id) !== 'undefined') {
		map.value?.removeLayer(props.spec.id)
	}
}

onMounted(() => {
	removeLayer()
	map?.value?.addLayer(props.spec, props.beforeId)
})

onUnmounted(() => {
	removeLayer()
})
</script>

<template>
	<div style="display: none"></div>
</template>
